import styled from "styled-components";

export const FormContainer = styled.div`
background: #f8f8f9;
height: auto;
form {
  background: #f8f8f9;
  display: flex;
  display: block;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: auto;
  max-width: 400px;
  padding-top: 40px;

  .labelcoord {
    width: 100%;
    margin-bottom: 10px;
    /* margin-left: 25px; */
    font-family: Lato;
    font-size: 11px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #8a92a2;
  }

  .coord {
    width: 100%;
    height: 75px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    
    .partCoord {
      width: 30%;
      height: 90px;

      span {
        position: relative;
        top: -100px;
        left: 123px;
        color: #8a92a2;
        font-weight: 500;
      }
    }
  }

  i {
  margin-left: 15px;
}

#labelcultura{
  margin: 0px 0px 0px 25px;
  font-family: Lato;
  font-size: 14px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #586377;
}

#multiselectContainerReact{
  margin: 40px 0 10px 0;
  ._2OR24XnUXt8OCrysr3G0XI{
    margin-top: -34px;
    .searchBox{
      margin: 5px 0 30px 10px;
    }      
    span{
      background: #00b43f;
      width: auto;
    }
    background: white;
    width: 100%;
    border-radius: 25px;
  }

}
}

margin: 0px;

@media only screen and (max-width: 411px) {
  form {
    width: 100%;
    height: auto;

  }
  button {
    width: 100%;
  }
}

`;

export const ContainerInput = styled.div`
    width: 100%;
    height: auto;

    display: flex;
    align-items: center;
    flex-direction: column;

    @media (max-width: 990px) {
      height: 105px;
    }
`